const IGV = 0.18;

function calcularSubtotal(monto, igv = IGV) {
  const num = Number(monto);
  if (!Number.isFinite(num) || num <= 0) return 0;
  return num / (1 + igv);
}

/**
 * Replica el objeto enviado en el front Vue (Externo_ficha_de_reserva_de_cita.vue) para POST /api/documents.
 */
export function buildQuimedikDocumentPayload({
  ruc_dni_en_factura,
  nombre_razon_social_en_factura,
  document_type,
  costo_de_consulta,
  fecha_de_atencion,
  hora_de_atencion,
  numero_de_historia_clinica,
  codigo_hist,
  titulo_servicio,
  paciente_completo,
  culqiPaymentId,
}) {
  const docTypeFromForm = String(document_type ?? '').trim();
  const rucRaw = String(ruc_dni_en_factura ?? '').replace(/\s/g, '');
  const receptorNombre = String(nombre_razon_social_en_factura ?? '').trim();
  if (!rucRaw || !receptorNombre) {
    console.warn('[buildQuimedikDocumentPayload] Faltan datos de receptor para comprobante electrónico');
    return null;
  }

  const monto = Number(costo_de_consulta);
  if (!Number.isFinite(monto) || monto <= 0) {
    console.warn('[buildQuimedikDocumentPayload] Monto inválido');
    return null;
  }

  const ahora = new Date();
  const opcionesFecha = {
    timeZone: 'America/Lima',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  const opcionesHora = {
    timeZone: 'America/Lima',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  const fecha_actual = new Intl.DateTimeFormat('fr-CA', opcionesFecha).format(ahora);
  const hora_actual = new Intl.DateTimeFormat('en-GB', opcionesHora).format(ahora);
  const fechaVencimientoObj = new Date(ahora);
  fechaVencimientoObj.setMonth(fechaVencimientoObj.getMonth() + 1);
  const fechaVencimiento = new Intl.DateTimeFormat('fr-CA', opcionesFecha).format(fechaVencimientoObj);

  const baseGravado = calcularSubtotal(monto);
  const igvAmount = monto - baseGravado;
  const digitosDoc = rucRaw.replace(/\D/g, '');
  /** Factura (01 / RUC 6): tipo explícito en formulario o 11 dígitos como respaldo */
  const esFactura = docTypeFromForm === 'RUC' || digitosDoc.length === 11;

  const tituloConsulta = titulo_servicio || 'Consulta web';
  /** En factura muchos PDF muestran nombre_pdf como cliente; debe ser la razón social del formulario */
  const nombrePdfLinea = esFactura ? receptorNombre : tituloConsulta;
  const historia = numero_de_historia_clinica ?? '';
  const pacienteNombre = paciente_completo || '';
  const ticketId = codigo_hist ?? '';

  return {
    serie_documento: esFactura ? 'F001' : 'B001',
    numero_documento: '#',
    fecha_de_emision: fecha_actual,
    hora_de_emision: hora_actual,
    codigo_tipo_operacion: '0101',
    codigo_tipo_documento: esFactura ? '01' : '03',
    codigo_tipo_moneda: 'PEN',
    fecha_de_vencimiento: fechaVencimiento,
    datos_del_cliente_o_receptor: {
      codigo_tipo_documento_identidad: esFactura ? '6' : '1',
      numero_documento: esFactura ? digitosDoc || rucRaw : rucRaw,
      apellidos_y_nombres_o_razon_social: receptorNombre,
      codigo_pais: 'PE',
      ubigeo: '150101',
    },
    totales: {
      total_exportacion: 0.0,
      total_operaciones_gravadas: baseGravado,
      total_operaciones_inafectas: 0.0,
      total_operaciones_exoneradas: 0.0,
      total_operaciones_gratuitas: 0.0,
      total_igv: igvAmount,
      total_impuestos: igvAmount,
      total_valor: baseGravado,
      total_venta: monto,
    },
    items: [
      {
        codigo_interno: 'C0100',
        descripcion: esFactura ? `Consulta web — ${tituloConsulta}` : 'Consulta web',
        unidad_de_medida: 'ZZ',
        cantidad: 1,
        valor_unitario: baseGravado,
        codigo_tipo_precio: '01',
        precio_unitario: monto,
        codigo_tipo_afectacion_igv: '10',
        total_base_igv: baseGravado,
        porcentaje_igv: 18,
        nombre_pdf: nombrePdfLinea,
        total_igv: igvAmount,
        total_impuestos: igvAmount,
        total_valor_item: baseGravado,
        total_item: monto,
      },
    ],
    informacion_adicional:
      `Comprobante (receptor): ${receptorNombre} | Doc: ${rucRaw} | Paciente atendido: ${pacienteNombre} | Pago Culqui ` +
      String(culqiPaymentId ?? '') +
      ' | ' +
      String(fecha_de_atencion ?? '') +
      ' / ' +
      String(hora_de_atencion ?? '') +
      ' | HC:' +
      String(historia) +
      ' | Ticket Id:' +
      String(ticketId),
  };
}
